export * from '@fhs/routing/src/routes/v2/menu/[slug]';
export { default } from '@fhs/routing/src/routes/v2/menu/[slug]';
